import { Component, computed, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { OccurrenceService } from './core/services/occurrence.service';
import { Occurrence } from './core/models/occurrence';
import { LayoutComponent } from '@onrsr/ui/layout';
import { AuthService } from '@onrsr/ui/auth';
import { LoaderComponent as Loader } from '@onrsr/ui/widgets';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LayoutComponent, Loader],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.scss'
})
export class App {
  private authService = inject(AuthService);

  // Computed loading state based on auth initialization
  isLoading = computed(() => !this.authService.isInitialized());

  // Computed authentication state
  isAuthenticated = computed(() => this.authService.isUserAuthenticated());

  // Computed logout state
  isLoggingOut = computed(() => this.authService.isUserLoggingOut());

  protected readonly title = signal('onrsr-portal-ui');

  occurrences = signal<Occurrence[]>([]);
  
  constructor(private occurrenceService: OccurrenceService) {
    this.occurrenceService.getOccurrences().subscribe((occurrences) => {
      this.occurrences.set(occurrences.items);

      console.log(this.occurrences());
    });
  }
}
